// Vue Libraries
import VueRouter from "vue-router";

// Our Pages
import HomePage from "@/pages/HomePage";
import CoursePage from "@/pages/CoursePage";
import UploadPage from "@/pages/UploadPage";
import RatePage from "@/pages/RatePage";
import ProfilePage from "@/pages/ProfilePage";

let routes = [
    {
        path: "/",
        name: "home",
        component: HomePage,
    },
    {
        path: "/",
        name: "login",
        component: HomePage,
        props: {
            showLoginModal: true
        }
    },
    {
        path: "/courses/:course",
        name: "course",
        component: CoursePage,
    },
    {
        path: "/rate/:course",
        name: "rate",
        component: RatePage,
    },
    {
        path: "/u",
        name: "profile",
        component: ProfilePage,
    },
];

if (process.env.NODE_ENV === "development") {
    routes = routes.concat([
        {
            path: "/uploads",
            name: "uploads",
            component: UploadPage,
        },
    ]);
}

const router = new VueRouter({
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

export default router;
